'use strict';
window.FoG = window.FoG || {};

window.FoG.Modal = (function($) {
  function showModal(modalId, $content, onClose) {
    var $modal = $('#' + modalId);
    var isString = ('string' === typeof($content));
    
    var $modalMain = $modal.find('main').empty();
    
    if (isString) { $modalMain.text($content); }
    else { $modalMain.append($content); }

    NA.Modal.triggerModal(modalId);
    
    if (onClose) {
      $modal.on('na-modal-closed', () => {
        onClose();
        $modal.off('na-modal-closed');
      });
    }
  }
  
  function message($content, $onClose) {
    showModal('modal--message', $content, $onClose);
  }
  
  function error($content) {
    showModal('modal--error', $content);
  }
  
  function errorFromAjaxResponse(response) {
    var msg = NA.Ajax.errorFromResponse(response);

    if (!response) {
      msg = "Something went wrong.  Please try again later.";
    }
    
    FoG.Modal.error($('<span></span>').text(msg));
  }
  
  return {
    error: error,
    errorFromAjaxResponse: errorFromAjaxResponse,
    message: message,
    showModal: showModal,
  };
})(jQuery);